export default "__VITE_ASSET__87e22589__"